import React from 'react';
import BioPixelLogo from './BioPixelLogo';
import BioTrackerLogo from './BioTrackerLogo';
import Title from './Title';

export default function Header(props: any) {
  const isMobile = window.innerWidth <= 768; // Simple check for mobile
  if (props.hideOnMobile && isMobile) return null;

  return (
    <div className="header-shell">
      <BioTrackerLogo onClick={props.onLogoClick} />
      {props.showTitle ? <Title opacity={props.opacity} /> : null}
      <BioPixelLogo />
    </div>
  )
}